

<h2 class="flex w-full p-2 bg-primary-500 text-white uppercase font-semibold">
    {{data.title()}}
</h2>
<img [src]="data.imageFile" alt="img" class="max-w-4xl max-h-4xl">
